import { createSelector } from '@ngrx/store';

import { getCitation } from './get.citations';
import { ChevronData } from '../../models';

export const getSelectedChevronData = createSelector(
  getCitation,
  ({ chevronData }): ChevronData => chevronData
);
